import { DriverDebt } from "@daytrip/legacy-models";

import { ModelOperator } from "./ModelOperator";
import { ModelOperatorOptions } from "./ModelOperatorOptions";

interface DriverDebtOperatorOptions extends ModelOperatorOptions<DriverDebt, null, null> {}

export class DriverDebtOperator extends ModelOperator<DriverDebt, DriverDebtOperatorOptions, null, null, null> {}
